import CryptoJs from "crypto-js";

export default {
  methods: {
    encrypt(data) {
      return CryptoJs.AES.encrypt(
        JSON.stringify(data),
        "CRYPT_MICONTA_KEY_VUE_SECRET"
      );
    },
    decrypt(hash) {
      const obj = CryptoJs.AES.decrypt(hash, "CRYPT_MICONTA_KEY_VUE_SECRET");
      return JSON.parse(obj.toString(CryptoJs.enc.Utf8));
    }
  }
};
